import { Draw, Modify } from "ol/interaction";
import { measureSegmentsStyle, modifyStyle } from "../../styles/mapStyles";
import type { Map } from "ol";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";

export function getMeasureInteraction(source: any, modify: any, measuringType: any) {
    let tip = 'Кликните для начала измерений'
    let draw = new Draw({
        source: source,
        type: measuringType,
        style: function (feature) {
            return measureSegmentsStyle(modify, feature, true, measuringType, tip);
        }
    });
    draw.on('drawstart', function () {
        modify.setActive(false);
        tip = 'Кликните для продолжения измерения ' + (measuringType === 'Polygon' ? 'площади' : 'линии')
    });
    draw.on('drawend', function () {
        modify.setActive(true);
        tip = 'Кликните для начала измерений'
    });
    return draw
}

export function activateMeasureFunctions(map?: Map, isMeasureClicked?: boolean, isPolygonClicked?: boolean) {
    const source = new VectorSource();
    const modify = new Modify({ source: source, style: modifyStyle });
    const vector = new VectorLayer({
        source: source,
        style: function (feature) {
            return measureSegmentsStyle(modify, feature, true);
        },
    });
    map?.addLayer(vector);
    let draw: any
    if (isMeasureClicked) {
        draw = getMeasureInteraction(source, modify, "LineString")
    }
    if (isPolygonClicked) {
        draw = getMeasureInteraction(source, modify, 'Polygon')
    }
    if (isMeasureClicked || isPolygonClicked) {
        modify.setActive(true);
        map?.addInteraction(draw);
    }
    return {
        off: () => {
            map?.removeInteraction(draw);
            map?.removeLayer(vector);
        }
    }
}